import store from "@/store/index.store"
import CoachLayout from "@/layouts/CoachLayout.vue"

// Coach Dashboard Pages
const CoachHub = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachHub"
  )
const CoachDashboard = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachDashboard"
  )
const CoachSessionHistory = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachSessionHistory"
  )
const CoachReportCard = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachReportCard"
  )
const CoachTutorial = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachTutorial"
  )
const CoachSettings = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachSettings"
  )
const CoachConfiguration = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachConfiguration"
  )
const CoachStats = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/CoachStats.vue"
  )
const Students = () =>
  import(
    /* webpackChunkName: "coach-dashboard" */ "@/pages/user-accounts/coach/Students.vue"
  )

export default [
  {
    path: "/instapro/coach",
    redirect: "/instapro/coach/dashboard",
    name: "CoachHub",
    meta: {
      layout: {
        component: CoachLayout,
      },
    },
    component: CoachHub,
    beforeEnter: async (to, from, next) => {
      await store.dispatch("User/Coaching/loadInstaProAccessToken")
      await store.dispatch("User/Coaching/loadInstaProUser")
      if (!store.getters["User/Coaching/CoachInfo/getInstaProCoach"]) {
        next("/instapro")
        return
      }

      await Promise.all([
        store.dispatch("Games/loadGames"),
        store.dispatch("Coaching/loadInstaProGames"),
        store.dispatch("User/Coaching/CoachInfo/loadCurrentPayoutPeriod"),
        store.dispatch("User/Coaching/SessionRequests/loadActionableSessionRequests"),
        store.dispatch("Instapro/Vod/Coach/loadPendingRequests"),
        store.dispatch("Instapro/Vod/Coach/loadPickableVodRequests"),
      ])

      // If there are any actionable sessions, redirect user the dashboard
      const dashboardPath = "/instapro/coach/dashboard"
      if (to.path !== dashboardPath) {
        const hasActiveSession =
          store.getters["User/Coaching/SessionRequests/getActiveSessions"]
            .length > 0
        const hasPendingSessionRequestsInQueue =
          store.getters["User/Coaching/SessionRequests/getSessionRequestQueue"]
            .length > 0
        if (hasActiveSession || hasPendingSessionRequestsInQueue) {
          next(dashboardPath)
          return
        }
      }
      next()
    },
    children: [
      {
        path: "dashboard",
        name: "CoachDashboard",
        component: CoachDashboard,
      },
      {
        path: "stats",
        name: "CoachStats",
        component: CoachStats,
      },
      {
        path: "history",
        name: "CoachSessionHistory",
        component: CoachSessionHistory,
      },
      {
        path: "history/:sessionId",
        name: "CoachReportCard",
        component: CoachReportCard,
        beforeEnter: async (_to, from, next) => {
          try {
            await store.dispatch(
              "User/Coaching/fetchReportCardById",
              _to.params.sessionId
            )
            next()
          } catch (error) {
            console.log(error)
            next()
          }
        },
      },
      {
        path: "tutorial",
        name: "CoachTutorial",
        component: CoachTutorial,
      },
      {
        path: "settings",
        name: "CoachSettings",
        component: CoachSettings,
      },
      {
        path: "configuration",
        name: "CoachConfiguration",
        component: CoachConfiguration,
      },
      {
        path: "students",
        name: "Students",
        component: Students,
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/router/user-accounts/coach.routes.js